<template>
  <div class="container">
    <div class="page page-404">
      <div class="page-404__title">Error</div>
      <h1>{{ $vuetify.lang.t('$vuetify.error') }}</h1>
      <div class="page-404__description">
        {{ $vuetify.lang.t('$vuetify.contactAdmin') }}
      </div>
      <router-link to="/" class="btn btn-primary link-not-like">
        {{ $vuetify.lang.t('$vuetify.goMain') }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorLayout"
}
</script>

<style scoped>

</style>